import React, { FC, useContext, useEffect, useState } from "react";
import { Button, Typography } from "@material-ui/core";
import { FiltersContext } from "../../context";
import { BUTTONS, CONTEXT } from "../../constants";

const ClearFilters: FC = () => {
  const [filtersContext, setFiltersContext] = useContext(FiltersContext);
  const [filtersApplied, setfiltersApplied] = useState(false);

  const handleClearFilters = () => setFiltersContext(CONTEXT.FILTERS);

  useEffect(() => {
    const areFiltersApplied = Object.keys(filtersContext).some((section) => filtersContext[section].length > 0);
    setfiltersApplied(areFiltersApplied);
  }, [filtersContext]);

  return (
    <>
      {filtersApplied && (
        <Button size="small" variant="contained" onClick={() => handleClearFilters()}>
          <Typography variant="button">{BUTTONS.CLEAR_FILTERS}</Typography>
        </Button>
      )}
    </>
  );
};

export default ClearFilters;
